import style from "./LocationList.module.scss"
import Pagination, {LIMIT_PAGINATION} from "../IU/Pagination/Pagination";
import React from "react";
import ListOptions from "../ListOptions";

const CountryList = ({locations, page, setPage}: any) => {
    return <table className={style["wrapper"]}>
        <thead>
        <tr className={style['header']}>
            <th className={style['id']}>#</th>
            <th className={style['name']}>Pays</th>
            <th className={style['countryCode']}>Code Pays</th>
            <th className={style['phoneCode']}>Code telephonique</th>
            <th className={style['emoji']}>Emoji</th>
            <th className={style['options']}></th>
        </tr>
        </thead>
        <tbody>
        {locations?.countries?.map((location)=>(
            <tr key={location.id}>
                <td className={style['id']} data-label="id">{location?.id}</td>
                <td className={style['name']} data-label="name">{location?.name}</td>
                <td className={style['countryCode']} data-label="countryCode">{location?.countryCode}</td>
                <td className={style['phoneCode']} data-label="phoneCode">{location?.phoneCode}</td>
                <td className={style['emoji']} data-label="emoji">{location?.emoji}</td>
                <td className={style['']}>
                    <ListOptions data={location} page={page}/>
                </td>
            </tr>
        ))}
        </tbody>
        <tfoot>
        <tr>
            <td colSpan={17}>
                <Pagination
                    page={page}
                    setPage={setPage}
                    isEmpty={locations?.length === 0 || !locations || locations?.length < LIMIT_PAGINATION}
                    totalOfItems={locations?.totalCount}
                />
            </td>
        </tr>
        </tfoot>
    </table>
}

export default CountryList